// Central label for the professional linked to a patient.
// Never hardcode "Conselheiro(a)" in screens — use this helper.
export function professionalLabel(type) {
  return type === "psychologist" ? "Psicólogo(a)" : "Conselheiro(a)";
}
